import { FaRegStar, FaStar } from "react-icons/fa";

const TOTAL_STARS = 5;

const ReviewRatingInput = ({
  value = 0,
  onChange,
  label,
  size = 24,
  disabled = false,
  name = "rating",
}) => {
  const handleKeyDown = (event, ratingValue) => {
    if (disabled) return;

    if (event.key === "ArrowRight" || event.key === "ArrowUp") {
      event.preventDefault();
      onChange(Math.min(TOTAL_STARS, value + 1));
    }

    if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
      event.preventDefault();
      onChange(Math.max(1, value - 1));
    }

    if (event.key === "Home") {
      event.preventDefault();
      onChange(1);
    }

    if (event.key === "End") {
      event.preventDefault();
      onChange(TOTAL_STARS);
    }

    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      onChange(ratingValue);
    }
  };

  return (
    <div className="space-y-2">
      {label ? (
        <p className="text-sm font-semibold text-slate-700">{label}</p>
      ) : null}

      <div
        role="radiogroup"
        aria-label={label || "Review rating"}
        className="flex items-center gap-1"
      >
        {Array.from({ length: TOTAL_STARS }, (_, index) => {
          const ratingValue = index + 1;
          const selected = ratingValue <= value;
          const Icon = selected ? FaStar : FaRegStar;

          return (
            <button
              key={ratingValue}
              type="button"
              role="radio"
              name={name}
              aria-checked={value === ratingValue}
              aria-label={`${ratingValue} star${ratingValue > 1 ? "s" : ""}`}
              disabled={disabled}
              tabIndex={value === ratingValue || (value === 0 && ratingValue === 1) ? 0 : -1}
              onClick={() => onChange(ratingValue)}
              onKeyDown={(event) => handleKeyDown(event, ratingValue)}
              className="rounded-full p-1 text-amber-400 outline-none transition-transform hover:scale-105 focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <Icon size={size} />
            </button>
          );
        })}

        <span className="ml-2 text-sm font-medium text-slate-600">
          {value}/5
        </span>
      </div>
    </div>
  );
};

export default ReviewRatingInput;
